<template>
  <a-card :bordered="false" v-if='checkResult'>
    <div>
      <a-steps class="steps" :current="currentTab">
        <a-step title="1.确认有效评标价参数" />
        <a-step title="2.确认投标报价" />
<!--        <a-step title="3.评标基准价计算方法抽取" />-->
        <a-step title="4.确认进入评标基准价计算的投标报价" />
        <a-step title="5.评标基准价计算" />
      </a-steps>
      <div class="content">
        <WaterTransportBenchmarkPriceComputeStep1 :sectionId='sectionId' :bidProjectId='bidProjectId' v-if="currentTab === 0" @nextStep="nextStep"/>
        <WaterTransportBenchmarkPriceComputeStep2 :sectionId='sectionId' :bidProjectId='bidProjectId' v-if="currentTab === 1" @prevStep="prevStep" @nextStep="nextStep"/>
<!--        <WaterTransportBenchmarkPriceComputeStep3 :sectionId='sectionId' :bidProjectId='bidProjectId' v-if="currentTab === 2" @nextStep="nextStep" @prevStep="prevStep"/>-->
        <WaterTransportBenchmarkPriceComputeStep4 :sectionId='sectionId' :bidProjectId='bidProjectId' v-if="currentTab === 2" @prevStep="prevStep" @nextStep="nextStep"/>
        <WaterTransportBenchmarkPriceComputeStep5 :sectionId='sectionId' :bidProjectId='bidProjectId' v-if="currentTab === 3" @prevStep="prevStep" @finish="finish"/>
      </div>
    </div>
  </a-card>
</template>

<script>
  import WaterTransportBenchmarkPriceComputeStep1 from './WaterTransportBenchmarkPriceComputeStep1'
  import WaterTransportBenchmarkPriceComputeStep2 from './WaterTransportBenchmarkPriceComputeStep2'
  import WaterTransportBenchmarkPriceComputeStep3 from './WaterTransportBenchmarkPriceComputeStep3'
  import WaterTransportBenchmarkPriceComputeStep4 from './WaterTransportBenchmarkPriceComputeStep4'
  import WaterTransportBenchmarkPriceComputeStep5 from './WaterTransportBenchmarkPriceComputeStep5'
  import { StatusMixin } from '@/mixins/StatusMixin'
  import { getAction } from '@api/manage'

  export default {
    name: "WaterTransportBenchmarkPriceCompute",
    components: {
      WaterTransportBenchmarkPriceComputeStep1,
      WaterTransportBenchmarkPriceComputeStep2,
      WaterTransportBenchmarkPriceComputeStep3,
      WaterTransportBenchmarkPriceComputeStep4,
      WaterTransportBenchmarkPriceComputeStep5
    },
    mixins: [StatusMixin],
    data () {
      return {
        currentTab: null,
        sectionId: null,
        bidProjectId: null,
        // 基准价抽取允许方法
        way: [0,0],
      }
    },
    props: ['checkId'],
    methods: {
      setBidProjectId(tenderId ,sectionId) {
        //1.根据招标编号ID获取招标项目信息和项目信息
        this.sectionId = sectionId;
        this.bidProjectId = tenderId
        this.currentTab = 0;
        this.queryStatus();
        this.getBoOpenStatus();
      },
      //判定开标现场是否抽取评标基准价的计算方法
      getBoOpenStatus() {
        let that = this;
        getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
          sectionId: that.sectionId,
        }).then((res) => {
          if (res.success) {
            if(res.result.isKstandPriceFinish==1){
              that.currentTab = 3;
            }else {
              that.currentTab = 0;
            }
          }
        })
      },
      nextStep () {
        if (this.currentTab < 4) {
          this.currentTab += 1
        }
      },
      prevStep () {
        if (this.currentTab > 0) {
          this.currentTab -= 1
        }
      },
      finish () {
        this.currentTab = 0
      }
    }
  }
</script>

<style lang="less" scoped>
  /*.steps {*/
  /*  max-width: 750px;*/
  /*  margin: 16px auto;*/
  /*}*/
</style>